import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { sec } from "../../../security";

const apiServerUrl = process.env.REACT_APP_HAISTACK_API_URL;
export const practiceTypeApi = createApi({
  reducerPath: "practiceType",
  tagTypes: ["PracticeTypes"],
  baseQuery: fetchBaseQuery({
    baseUrl: apiServerUrl,
    prepareHeaders: async (headers) => {
      const token = await sec.getAccessTokenSilently()();

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      return headers;
    }
  }),
  endpoints: (builder) => ({
    getPracticeTypes: builder.query({
      query: () => "api/v2/practice_types",
      transformResponse: (response: any) => {
        return response.practice_types;
      }
    })
  })
});

export const { useGetPracticeTypesQuery } = practiceTypeApi;
